import {Identifiable} from './identifiable';

export interface ProjectReferencePhoto extends Identifiable {
    photo: boolean;
    originalUrl: string|null;
    position: number|null;
    primary: boolean;
    focusX: number;
    focusY: number;
    width: number;
    height: number;
    srcset: {[size: string]: string};
}

export interface LocalProjectReferencePhoto {
    localFile: File;
    position: number;
}

export type ProjectReferencePhotoType = ProjectReferencePhoto | LocalProjectReferencePhoto;

export function isLocalProjectReferencePhoto(value: ProjectReferencePhotoType): value is LocalProjectReferencePhoto {
    return 'localFile' in value;
}

export function isRemoteProjectReferencePhoto(value: ProjectReferencePhotoType): value is ProjectReferencePhoto {
    return 'photo' in value;
}

export function determineWidthAndHeight(photoReference: LocalProjectReferencePhoto): Promise<{width: number, height: number}> {
    return new Promise((resolve) => {
        const fr = new FileReader();
        fr.onload = () => {
            const image = new Image;
            image.onload = () => {
                resolve({width: image.width, height: image.height});
            }

            image.src = fr.result as string;
        };
        photoReference.localFile.arrayBuffer().then(arrayBuffer => {
            const blob = new Blob([new Uint8Array(arrayBuffer, 0, arrayBuffer.byteLength)]);
            fr.readAsDataURL(blob)
        });
    });
}
